'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveScrollableAncestorProp;
function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-waypoint/build/resolveScrollableAncestorProp.js
// module id = ./node_modules/react-waypoint/build/resolveScrollableAncestorProp.js
// module chunks = 168707334958949